export default {"src":"/_next/static/media/chevronRight.ea9722de.svg","height":13,"width":13,"blurWidth":0,"blurHeight":0};